import { Box, Stack } from '@mui/material'
import { SxProps } from '@mui/system'
import { FC } from 'react'
import { EmphasizedNumber, GachaTicketThumbnail } from 'utoniq-ui'

export type HeaderDisplayProps = {
  ticket: number | string
  src: string
  size?: 'medium' | 'large'
  sx?: SxProps
}

export const HeaderDisplay: FC<HeaderDisplayProps> = ({
  ticket,
  size = 'medium',
  src,
  sx,
}) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="flex-end"
      direction="row"
      sx={{
        position: 'relative',
        bgcolor: size === 'large' ? 'transparent' : 'grey.100',
        borderRadius: 3,
        height: 20,
        minWidth: 56,
        px: 2,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 32,
          position: 'absolute',
          left: -12,
        }}
      >
        <GachaTicketThumbnail src={src} />
      </Box>
      <EmphasizedNumber variant={size === 'medium' ? 'subtitle1' : 'h1'}>
        {ticket}
      </EmphasizedNumber>
    </Stack>
  )
}
